export default __webpack_public_path__ + "static/media/logo.09be4318.png";